<template>
<div class="container">
<b-row v-if="!isLoading">
<b-container>
	<h4>
	<label>País</label>
	<select v-model="pais" @click="f_seleccione_facturas()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	</h4>
	<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_muestra">
	<md-table-toolbar>
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
		<md-button v-if="opcion == 4" class="md-primary" @click="f_grabe_asignacionAutomatica">Asignar</md-button>
	</md-table-toolbar>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell v-if="opcion == 4 || opcion==5" :md-label="labels.usuario" class="text-left border">{{f_usuario_nombre(item.id_usuario)}}</md-table-cell>
		<md-table-cell v-if="opcion!=3 && opcion!=4 && opcion!=1 && opcion!=5" :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
		<md-table-cell v-if="opcion!=5" :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
		<md-table-cell v-if="opcion!=5" :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidad_facturas" class="text-left border">{{item.cantidad}}</md-table-cell>
		<md-table-cell :md-label="labels.items" class="text-left border">{{item.items}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
<md-dialog :md-active.sync="muestreFacturas">
	<md-dialog-title class="text-center">
		<h3><b><i>{{f_titulo()}}</i></b> &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; </h3>
		<label v-if="muestreLiderUsuarios">Usuarios</label>
		<select v-if="muestreLiderUsuarios" v-model="usuario" @click="fgl_asignar=true;">
			<option
				v-for="(item, idx) in listLiderUsuarios"
				:key="'id_usuario-'+idx"
				:value="item.id_usuario">
				{{item.name}}
			</option>
		</select>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturasCliente" md-card md-fixed-header @md-selected="f_asigna_varias">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple">
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.documento" class="text-left border">{{item.documento}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.valor_total" class="text-right border">{{item.valor_total}}</md-table-cell>
				<md-table-cell :md-label="labels.items" class="text-right border">{{item.items}}</md-table-cell>
				<md-table-cell :md-label="labels.usuario" class="text-right border">{{f_usuario_nombre(item.id_usuario)}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button v-if="fgl_asignar" class="md-primary" @click="f_grabe_asignacion">Asignar</md-button>
			<md-button class="md-accent" @click="muestreFacturas=false;muestreLiderUsuarios=false;usuario=''">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="contabilizaFactura">
	<md-dialog-title class="text-center">
		<h3><b><i>{{f_titulo()}}</i></b> &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturasCliente" md-card md-fixed-header @md-selected="f_contabiliza">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.documento" class="text-left border">{{item.documento}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.impuesto_tot" class="text-right border">{{item.impuesto_total}}</md-table-cell>
				<md-table-cell :md-label="labels.valor_total" class="text-right border">{{item.valor_total}}</md-table-cell>
				<md-table-cell :md-label="labels.items" class="text-right border">{{item.items}}</md-table-cell>
				<md-table-cell :md-label="labels.estado" class="text-right border">{{f_estado(item.estado)}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="contabilizaFactura=false">Cerrar Contabilizacion</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="fgl_asignaAutomatica">
	<md-dialog-title class="text-center">
		<h3><b><i>{{f_titulo()}}</i></b> &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturasCliente" md-card md-fixed-header>
			<md-table-row slot="md-table-row" slot-scope="{ item }">
				<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.documento" class="text-left border">{{item.documento}}</md-table-cell>
				<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
				<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
				<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
				<md-table-cell :md-label="labels.impuesto_tot" class="text-right border">{{item.impuesto_total}}</md-table-cell>
				<md-table-cell :md-label="labels.valor_total" class="text-right border">{{item.valor_total}}</md-table-cell>
				<md-table-cell :md-label="labels.items" class="text-right border">{{item.items}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="fgl_asignaAutomatica=false">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="fgl_muestraDetalle">
	<md-dialog-title class="text-center">
		<h3><b><i>{{f_titulo_detalle()}}</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturaDetalle" md-card md-fixed-header @md-selected="f_ordenCompra">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.item" class="text-left border">{{item.item}}</md-table-cell>
				<md-table-cell :md-label="labels.codigo" class="text-left border">{{item.codigo}}</md-table-cell>
				<md-table-cell :md-label="labels.cantidad" class="text-left border">{{item.cantidad}}</md-table-cell>
				<md-table-cell :md-label="labels.descripcion_item" class="text-left border">{{item.descripcion}}</md-table-cell>
				<md-table-cell :md-label="labels.venta_bruta_factura" class="text-left border">{{f_precio_factura(item.valor_venta,item.impuesto1,item.impuesto2)}}</md-table-cell>
				<md-table-cell :md-label="labels.iva" class="text-left border">{{item.impuesto0}}</md-table-cell>
				<md-table-cell :md-label="labels.otroImpuesto" class="text-left border">{{item.impuesto1}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-table v-if="listFacturaDetalle.length==0">
			<md-table-row>
				<md-table-cell class="text-center border"><h3><i>Factura sin informacion</i></h3></md-table-cell>
			</md-table-row>
		</md-table>

		<md-dialog-actions>
			<md-button class="md-accent" @click="f_cierre_factura_detalle()">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="fgl_muestraOrdenCompra">
	<md-dialog-title class="text-center">
		<h3><b><i>{{f_titulo_orden_compra()}}</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="reg_factura" md-card>
			<md-table-cell class="text-left border">{{reg_factura.item}}</md-table-cell>
			<md-table-cell class="text-left border">{{reg_factura.codigo}}</md-table-cell>
			<md-table-cell class="text-left border">{{reg_factura.cantidad}}</md-table-cell>
			<md-table-cell class="text-left border">{{reg_factura.unidad}}</md-table-cell>
			<md-table-cell class="text-left border">{{reg_factura.descripcion}}</md-table-cell>
			<md-table-cell class="text-left border">{{reg_factura.precio_total}}</md-table-cell>
			<md-table-cell class="text-left border">{{f_precio_factura(reg_factura.valor_venta,reg_factura.impuesto1,reg_factura.impuesto2)}}</md-table-cell>
			<md-table-cell class="text-left border">{{reg_factura.impuesto0}}</md-table-cell>
		</md-table>
		<md-table v-model="listOrdenCompra" md-card md-fixed-header @md-selected="f_itemOrdenCompra">
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.item" class="text-left border">{{item.posicion}}</md-table-cell>
				<md-table-cell :md-label="labels.codigo" class="text-left border">{{item.material}}</md-table-cell>
				<md-table-cell :md-label="labels.cantidad" class="text-left border">{{item.cantidad_por_calcular}}</md-table-cell>
				<md-table-cell :md-label="labels.descripcion_item_orden" class="text-left border">{{item.descripcion}}</md-table-cell>
				<md-table-cell :md-label="labels.venta_bruta" class="text-left border">{{item.valor_por_calcular}}</md-table-cell>
				<md-table-cell :md-label="labels.item_factura" class="text-left border">{{item.item_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.cantidad_facturada" class="text-left border"><input v-model="item.cantidad_facturada" maxlength="6" size="6"></md-table-cell>
				<md-table-cell :md-label="labels.precio_facturado" class="text-left border">{{item.valor_precio_facturado}}</md-table-cell>
			</md-table-row>
		</md-table>
		<md-table v-if="listOrdenCompra.length==0">
			<md-table-row>
				<md-table-cell class="text-center border"><h3><i>No existe Orden de Compra</i></h3></md-table-cell>
			</md-table-row>
		</md-table>

		<md-dialog-actions>
			<md-button class="md-accent" @click="fgl_muestraOrdenCompra=false;fgl_muestraDetalle=true">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="fgl_visualizaOrdenCompra">
	<md-dialog-title class="text-center">
		<h3><b><i>{{f_titulo_orden_compra()}}</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listOrdenFacturas" md-card md-fixed-header>
			<md-table-row slot="md-table-row" slot-scope="{ item }">
				<md-table-cell :md-label="labels.item" class="border">{{item.posicion}}</md-table-cell>
				<md-table-cell :md-label="labels.codigo" class="border">{{item.material}}</md-table-cell>
				<md-table-cell :md-label="labels.cantidad" class="border">{{item.cantidad_por_calcular}}</md-table-cell>
				<md-table-cell :md-label="labels.descripcion_item_orden" class="border">{{item.descripcion}}</md-table-cell>
				<md-table-cell :md-label="labels.venta_bruta" class="border">{{item.valor_por_calcular}}</md-table-cell>
				<md-table-cell :md-label="labels.item_factura" class="border">{{item.item_factura}}</md-table-cell>
				<md-table-cell :md-label="labels.cantidad_facturada" class="border">{{item.cantidad_facturada}}</md-table-cell>
				<md-table-cell :md-label="labels.precio_facturado" class="border">{{item.valor_precio_facturado}}</md-table-cell>
				<md-table-cell v-if="valores==true" :md-label="labels.valoresQ" class="border"><b><i>{{f_valores_item(item.posicion,true,item.valor_por_calcular,item.valor_precio_facturado,item.cantidad_por_calcular,item.cantidad_facturada)}}</i></b></md-table-cell>
				<md-table-cell v-if="valores==true" :md-label="labels.valoresP" class="border"><b><i>{{f_valores_item(item.posicion,false,item.valor_por_calcular,item.valor_precio_facturado,item.cantidad_por_calcular,item.cantidad_facturada)}}</i></b></md-table-cell>
				<md-table-cell v-if="valores==true" :md-label="labels.diferenciasQ" class="border"><b><i>{{f_diferencias_item(item.posicion,true,item.valor_por_calcular,item.valor_precio_facturado,item.cantidad_por_calcular,item.cantidad_facturada)}}</i></b></md-table-cell>
				<md-table-cell v-if="valores==true" :md-label="labels.diferenciasP" class="border"><b><i>{{f_diferencias_item(item.posicion,false,item.valor_por_calcular,item.valor_precio_facturado,item.cantidad_por_calcular,item.cantidad_facturada)}}</i></b></md-table-cell>
			</md-table-row>
		</md-table>
		<md-table v-if="listOrdenFacturas.length==0">
			<md-table-row>
				<md-table-cell class="text-center border"><h3><i>Factura sin relacionar con la orden</i></h3></md-table-cell>
			</md-table-row>
		</md-table>

		<md-dialog-actions>
			<md-button class="md-accent" @click="valores=true">Valores</md-button>
			<md-button class="md-accent" @click="valores=false">Diferencias</md-button>
			<md-button class="md-accent" @click="f_cierre_visualizacion(true)">Cerrar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="muestreDetalleFactura">
	<md-dialog-title class="text-center">
		<h3><b><i>Registro Proceso Contabilizacion Factura</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table >
			<md-table-row >
				<md-table-cell v-if="factura.documento == 'NC'" class="text-right border">Nota Credito</md-table-cell>
				<md-table-cell v-else class="text-right border">Factura</md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{f_formato_fecha(factura.fecha_factura)}}</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{factura.factura}}</i></b></md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Identificación</md-table-cell>
				<md-table-cell class="text-left border">{{factura.identificacion}}</md-table-cell>
				<md-table-cell class="text-left border">{{factura.nombre}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border">Pedido/Doc Relacionado</md-table-cell>
				<md-table-cell v-if="fgl_relacionado==false"  class="text-left border"><b><i>{{factura.pedido}}</i></b></md-table-cell>
				<md-table-cell v-if="fgl_relacionado==true" class="text-left border"><b><i>{{relacionado.pedido}}</i></b></md-table-cell>
				<md-table-cell v-if="factura.remision != 'NULL'" class="text-left border">{{factura.remision}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria0 != null">
				<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria0}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto0.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria1 != null">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria1}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto1.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria2 != null">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria2}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto2.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria3 != null">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria3}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto3.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria4 != null">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria4}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto4.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.categoria5 != null">
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.categoria5}}</md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto5.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura">
				<md-table-cell class="text-right border">Valor</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.valor.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura">
				<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border">{{factura.impuesto_total.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura">
				<md-table-cell class="text-right border">Total</md-table-cell>
				<md-table-cell class="text-center border"><h3><b><i>{{f_estado(factura.estado)}}</i></b></h3></md-table-cell>
				<md-table-cell class="text-right border"><b><i>{{factura.valor_total.replace('.',',')}}</i></b></md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.id_lider >0">
				<md-table-cell class="text-right border">Lider/Asignado</md-table-cell>
				<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_lider)}}</md-table-cell>
				<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_usuario)}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura">
				<md-table-cell class="text-right border">No Homologados/Homologados</md-table-cell>
				<md-table-cell class="text-left border">{{noHomologados}}</md-table-cell>
				<md-table-cell class="text-left border">{{homologados}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="diferencias != 0">
				<md-table-cell class="text-right border">Diferencias</md-table-cell>
				<md-table-cell class="text-left border"></md-table-cell>
				<md-table-cell class="text-left border">{{diferencias.replace('.',',')}}</md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.llave">
			<md-table-cell class="text-right border"><b><i>Llave/Detraccion</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{factura.llave}}</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{factura.detraccion}}</i></b></md-table-cell>
			</md-table-row>
			<md-table-row v-if="relacionado">
				<md-table-cell v-if="relacionado.documento == 'NC'" class="text-right border"><b><i>Relacionado (Nota Credito)</i></b></md-table-cell>
					<md-table-cell v-else class="text-right border"><b><i>Relacionado (Factura)</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{f_formato_fecha(relacionado.fecha_factura)}}</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{relacionado.factura}}</i></b></md-table-cell>
			</md-table-row>
			<md-table-row v-if="relacionado">
				<md-table-cell class="text-right border"><b><i>Relacionado(Total)</i></b></md-table-cell>
				<md-table-cell class="text-center border"><h3><b><i>{{f_estado(relacionado.estado)}}</i></b></h3></md-table-cell>
				<md-table-cell class="text-right border"><b><i>{{relacionado.valor_total.replace('.',',')}}</i></b></md-table-cell>
			</md-table-row>
			<md-table-row v-if="relacionado && relacionado.llave">
				<md-table-cell class="text-right border"><b><i>Relacionado(Llave/Detraccion)</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{relacionado.llave}}</i></b></md-table-cell>
				<md-table-cell class="text-left border"><b><i>{{relacionado.detraccion}}</i></b></md-table-cell>
			</md-table-row>
		</md-table>
		<md-table>
			<md-table-row v-if="estado.observaciones || estado.contabiliza">
				<md-table-cell v-if="estado.contabiliza" class="text-left border">
					<md-field><md-input v-model="factura.documento_contable" @input="f_verifique_doc_contable(factura.documento_contable)" placeholder="Documento Contable"></md-input></md-field>
				</md-table-cell>
				<md-table-cell v-if="estado.observaciones" class="text-right border">
					<md-field><md-textarea v-model="observaciones" rows="10" cols="50" placeholder="Observaciones"></md-textarea></md-field>
				</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-primary" @click="f_visualizar(true)">Visualizar</md-button>
			<md-button class="md-primary" @click="f_actualiza_contab_inicial()">Asignar</md-button>
			<select v-if="factura.inicia_contab != null && (listFacturaDetalle.length > 0 || factura.archivo=='MANUAL') && listRazones.length>0" v-model="factura.razon_estado">
				<option
					v-for="(item, idx) in listRazones"
					:key="'razon-'+idx"
					:value="item.razon">
					{{item.razon}}-{{item.descripcion}}({{f_estado(item.estado)}})
				</option>
			</select>
			<md-button v-if="factura.inicia_contab != null && factura.razon_estado && !grabar" class="md-primary" @click="f_pide_adicional()">Registrar</md-button>
			<md-button v-if="factura.inicia_contab != null && factura.razon_estado && grabar" class="md-primary" @click="f_actualiza_contab(false);factura.inicia_contab=null">Grabar</md-button>
			<md-button class="md-accent" @click="muestreDetalleFactura = false;contabilizaFactura=true;factura.inicia_contab=null">Regresar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
</b-row>
</div>
</template>
<script>
import Factura from "@/services/Facturas"
import Lider from "@/services/Lideres"
import User from "@/services/User"
import Razon from "@/services/Razones"
import Estado from "@/services/Estados"

export default {
name:'Facturas',
data: () => ({
	valores:true,
	isLoading: false,
	selecciona: false,
	fgl_asignar: false,
	fgl_asignaAutomatica: false,
	fgl_novedad: false,
	fgl_diferencias: false,
	fgl_adicionar_diferencias: false,
	fgl_muestraDetalle: false,
	fgl_muestraOrdenCompra: false,
	fgl_visualizaOrdenCompra: false,
	adicional: false,
	grabar: false,
	opcion: 0,
	diferencias: 0,
	noHomologados:0,
	homologados: 0,
	factura: '',
	relacionado: '',
	estado: '',
	observaciones: '',
	pais: '',
	usuario: '',
	titulo_factura: "",
	users : [],
	listPaises : [],
	listFacturas : [],
	listFacturasG : [],
	listFacturasCliente : [],
	listLiderUsuarios : [],
	asignaUsuario: [],
	muestreFacturas: false,
	muestreDetalleFactura: false,
	contabilizaFactura: false,
	muestreLiderUsuarios: false,
	listRazones : [],
	listRazonesLeidas : [],
	listEstados : [],
	novedad: {},
	novedad_item: {},
	novedad_detalle: [],
	valor_total_fe : 0,
	valor_total_sap : 0,
	listFacturaDetalle: [],
	listOrdenCompra: [],
	listOrdenFacturas: [],
	listHomologaciones: [],
	listControl: {},
	listControlRelacionado: {},
	reg_factura: {},
	fgl_analista: '',
	fecha_inicio_contab: '',
	fgl_relacionado: false,
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			documento : "Tipo",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad_facturas : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto_tot : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			item : "Item",
			descripcion : "Descripcion",
			precioFE : "PrecioFE",
			precioSAP : "PrecioSAP",
			cantidadFE : "CantFE",
			cantidadSAP : "CantSAP",
			ivaFE : "IvaFE",
			ivaSAP : "IvaSAP",
			impuestoFE : "ImpFE",
			impuestoSAP : "ImpSAP",
			diferencia_total : "DifTotal",
			valor_fe : "TotalFE",
			valor_sap : "TotalSAP",
			usuario : "Usuario",
			cantidad: "Cantidad",
			codigo: "Codido",
			descripcion_item: "Descripcion Producto --------------------------------",
			descripcion_item_orden: "Descripcion Orden Compra ----------------------------------------------",
			descripcion_novedad: "Descripcion ----------------------------------------------------------------------------------------",
			unidad: "UnEmpa",
			unitario: "Monto",
			venta_bruta: "Precio Ord",
			venta_bruta_factura: "Precio Fac",
			item_factura: "Item Fac",
			impuesto: "Impuesto",
			cantidad_facturada: "Cant Fac",
			precio_facturado: "Precio Fac",
			valoresQ: "Q SAP",
			valoresP: "P SAP",
			diferenciasQ: "DIFER Q",
			diferenciasP: "DIFER P",
			monto_facturado: "Monto Fac",
			iva: "IGV",
			otroImpuesto : "Imp Adic",
			estado: "Estado",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			item : "Item",
			descripcion : "Description",
			diferencia_precio : "Price Dif",
			diferencia_cantidad : "Amount Dif",
			diferencia_iva : "Iva Dif",
			diferencia_impuesto : "Other Tax Dif",
			diferencia_Total : "Total",
			diferencia_total : "Total Dif",
			valor_fe : "FE Value",
			valor_sap : "SAP Value",
		}
	}
}
},
mounted(){
	let fgl_lider =this.$store.state.userId 
	let fgl_usuario =this.$store.state.userId 

	if	(this.$route.name == "asignacion") {
		this.opcion=0
	}
	if	(this.$route.name == "asignacionprov") {
		this.opcion=3
	}
	if	(this.$route.name == "asignacionusuario") {
		this.opcion=4
	}
	if	(this.$route.name == "reasignacion") {
		this.opcion=1
	}
	if	(this.$route.name == "redisanalista") {
		this.opcion=5
	}
	if	(this.$route.name == "contabilizar") {
		this.opcion=2
	}
	Factura.leaFacturas("procesar",this.opcion,fgl_lider,fgl_usuario)
	.then((res) => {
		this.listFacturasG = res.data.listFacturas
		this.listPaises = res.data.listPaises
	})
	.catch((err) => {
		console.log(err)
	})
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
        Razon.leaRazones()
        .then((res) => {
            this.listRazonesLeidas = res.data.listRazones
        })
        .catch((err) => {
            console.log(err)
        })
        Estado.leaEstados(false)
        .then((res) => {
            this.listEstados = res.data.listEstados
        })
        .catch((err) => {
            console.log(err)
        })

},
methods:{
	f_titulo() {
		if	(this.$route.name == "asignacion") {
			this.opcion=0
			return "ASIGNACIÓN DE FACTURAS POR FECHA"
		}
		if	(this.$route.name == "reasignacion") {
			this.opcion=1
			return "REDISTRIBUCION DE FACTURAS POR PROVEEDOR"
		}
		if	(this.$route.name == "contabilizar") {
			this.opcion=2
			return "CONTABILIZACIÓN DE FACTURAS"
		}
		if	(this.$route.name == "asignacionprov") {
			this.opcion=3
			return "ASIGNACIÓN DE FACTURAS POR PROVEEDOR"
		}
		if	(this.$route.name == "asignacionusuario") {
			this.opcion=4
			return "ASIGNACIÓN AUTOMÁTICA DE FACTURAS"
		}
		if	(this.$route.name == "redisanalista") {
			this.opcion=5
			if	(this.fgl_analista.length == 0) {
				return "REDISTRIBUCION DE FACTURAS POR ANALISTA"
			} else {
				return "REDISTRIBUCION DE FACTURAS DE "+
					this.fgl_analista
			}
		}
		return "SIN INFORMACIÓN "+this.$route.name
	},
	f_titulo_novedad() {
		return "REGISTRO DE NOVEDADES "+this.estado.descripcion
	},
	f_titulo_diferencias() {
		return "REGISTRO DE DIFERENCIAS "+this.estado.descripcion
	},
	f_titulo_detalle() {
		return "ITEMS DOCUMENTO "+this.factura.factura+" ("+
			this.factura.nombre+")"
	},
	f_titulo_orden_compra() {
		return "ORDEN COMPRA "+this.factura.pedido+" DOCUMENTO "+
			this.factura.factura+" ("+
			this.factura.nombre+")"
	},
	f_muestra(r_proveedor) {
		let fgl_lider =this.$store.state.userId 
		let fgl_usuario =this.$store.state.userId 

		this.muestreLiderUsuarios=false
		this.muestreFacturas=false
		this.fgl_asignaAutomatica=false
		this.contabilizaFactura=false
		this.fgl_asignar=false
		this.fgl_analista=''
		if	(this.opcion == 5) {
			fgl_usuario = r_proveedor.id_usuario
			this.fgl_analista=this.f_usuario_nombre(r_proveedor.id_usuario)
		}
		Factura.leaFacturasCliente("procesar",r_proveedor.fecha_factura,r_proveedor.identificacion,this.opcion,fgl_lider,fgl_usuario)
		.then((res) => {
			this.listFacturasCliente = res.data.listFacturasCliente
			if	(this.listFacturasCliente.length == 0) {
				r_proveedor.cantidad=0
			} else {

				if	(this.$route.name == "contabilizar") {
					this.contabilizaFactura=true
				} else {
					if	(this.opcion == 4) {
						this.fgl_asignaAutomatica=true
					} else {
						this.muestreFacturas=true
					}
				}
			}
		})
		.catch((err) => {
			console.log(err)
		})
		
	},
	f_asigna_varias(r_facturas) {
		this.asignaUsuario=r_facturas
		this.fgl_asignar=false
		this.muestreLiderUsuarios=false
		if	(this.asignaUsuario.length > 0) {
			Lider.leaLiderUsuarios(this.$store.state.userId)
			.then((res) => {
				this.listLiderUsuarios= res.data.listLiderUsuarios
				if	(this.listLiderUsuarios.length>0) {
					this.muestreLiderUsuarios=true
				}
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	f_grabe_asignacion() {
		Factura.grabeAsignacion(this.opcion,this.$store.state.userId,this.usuario,this.asignaUsuario)
		.then(() => {
			this.$toast.success("Usuario Asignado a Facturas seleccionadas")
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al asignar Usuario")
		})
		this.asignaUsuario=[]
		this.fgl_asignar=false
		this.muestreFacturas=false
		this.muestreLiderUsuarios=false
		this.usuario=''
	},
	f_grabe_asignacionAutomatica() {
		if	(this.listFacturas.length == 0) {
			this.$toast.error("Proveedores sin seleccionar")
			return
		}
		Factura.grabeAsignacionAutomatica(this.$store.state.userId,this.listFacturas)
		.then(() => {
			this.$toast.success("Asignacion automatica completa")
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al asignar Automaticamente")
		})
		this.listFacturasG = []
		this.listPaises = []
		this.listFacturas=[]
		this.pais=''
	},

	f_contabiliza(r_factura) {
		this.listRazones=[]
		this.muestreDetalleFactura=true
		this.estado = {}
		this.contabilizaFactura=false
		this.factura = r_factura
		this.factura.inicia_contab=this.fecha_inicia_contab
		this.factura.razon_estado = ''
		this.factura.documento_contable=''
		this.observaciones=''
		this.fgl_novedad=false
		this.listOrdenFacturas=[]
		this.f_fecha_inicia_contab()
		this.factura.inicia_contab=this.fecha_inicia_contab
		if	(this.factura.pedido.length === 0) {
			this.factura.pedido = '-'
		}
		this.relacionado=''
		this.listControlRelacionado=[]
		this.fgl_relacionado = false

		Factura.leaRelacionado(this.factura.pais,this.factura.identificacion,this.factura.factura,this.factura.remision,this.factura.documento)
		.then((resrelacionado) => {
			this.relacionado = resrelacionado.data.listRelacionado[0]
			this.listControlRelacionado = resrelacionado.data.listControl
			if	(this.factura.documento == "NC") {
				if	(this.relacionado != undefined) {
					this.fgl_relacionado = true
				}
			}
			if	(this.listControlRelacionado.length > 0 ) {
				this.relacionado.llave = this.listControlRelacionado[0].car_sunat
				this.relacionado.detraccion = this.listControlRelacionado[0].detraccion
			}
		})
		.catch(() => {
			this.$toast.error("Problema al leer Relacionado")
			this.relacionado = []
			this.listControlRelacionado = []
		})
		Factura.leaOrdenFactura(this.factura.pais,this.factura.identificacion,this.factura.factura,this.factura.pedido)
		.then((res) => {
			this.listFacturaDetalle = res.data.listFacturaDetalle
			this.listOrdenCompra = res.data.listOrdenCompra
			this.listHomologaciones = res.data.listHomologaciones
			this.listControl = res.data.listControl
			if	(this.listControl.length > 0 ) {
				this.factura.llave = this.listControl[0].car_sunat
				this.factura.detraccion = this.listControl[0].detraccion
			} else {
				this.factura.llave = ''
				this.factura.detraccion = ''
			}
		})
		.then(() => {
			this.homologados=0
			this.noHomologados=this.factura.items
			this.diferencias=0
			this.listFacturaDetalle.forEach((factura,idx) => {
				if	(factura.categoria0 != "IGV") {
					const v_categoria = factura.categoria0
					const v_impuesto = factura.impuesto0
					this.listFacturaDetalle[idx].impuesto0=this.listFacturaDetalle[idx].impuesto1
					this.listFacturaDetalle[idx].categoria0=this.listFacturaDetalle[idx].categoria1
					this.listFacturaDetalle[idx].impuesto1=this.listFacturaDetalle[idx].impuesto2
					this.listFacturaDetalle[idx].categoria1=this.listFacturaDetalle[idx].categoria2
					this.listFacturaDetalle[idx].impuesto2=v_impuesto
					this.listFacturaDetalle[idx].categoria2=v_categoria
					factura=this.listFacturaDetalle[idx]
				}
				if	(factura.categoria0 != "IGV") {
					const v_categoria = factura.categoria0
					const v_impuesto = factura.impuesto0
					this.listFacturaDetalle[idx].impuesto0=this.listFacturaDetalle[idx].impuesto1
					this.listFacturaDetalle[idx].categoria0=this.listFacturaDetalle[idx].categoria1
					this.listFacturaDetalle[idx].impuesto1=this.listFacturaDetalle[idx].impuesto2
					this.listFacturaDetalle[idx].categoria1=this.listFacturaDetalle[idx].categoria2
					this.listFacturaDetalle[idx].impuesto2=v_impuesto
					this.listFacturaDetalle[idx].categoria2=v_categoria
					factura=this.listFacturaDetalle[idx]
				}
				if	(factura.categoria1 == undefined ||
					factura.categoria1 == null) {
					this.listFacturaDetalle[idx].impuesto1=this.listFacturaDetalle[idx].impuesto2
					this.listFacturaDetalle[idx].categoria1=this.listFacturaDetalle[idx].categoria2
					this.listFacturaDetalle[idx].impuesto2=null
					this.listFacturaDetalle[idx].categoria2=null
				}
			})
		})
		.then(() => {
			this.listFacturaDetalle.forEach((factura) => {
				const v_homologa=this.listHomologaciones.find((homologa) =>
					homologa.descripcion_proveedor==factura.descripcion)
				if	(v_homologa != undefined) {
					const idx=this.listOrdenCompra.findIndex((orden) =>
						orden.material==v_homologa.referencia_rappi)
					if	(idx >= 0 && this.listOrdenCompra[idx].item_factura == undefined) {
						this.listOrdenCompra[idx].item_factura=factura.item
						this.listOrdenCompra[idx].cantidad_facturada=this.f_embalaje(
							factura.cantidad,v_homologa.unidad_embalaje)
						this.listOrdenCompra[idx].valor_monto_facturado=factura.precio_venta
						this.listOrdenCompra[idx].valor_precio_facturado=this.f_precio_factura(
							factura.valor_venta,factura.impuesto1,factura.impuesto2)
						this.listOrdenCompra[idx].impuesto=factura.impuesto0
						this.listOrdenCompra[idx].impuesto_adicional=this.f_impuesto_adicional(
							factura.impuesto1,factura.impuesto2)
						this.listOrdenCompra[idx].homolgado=true
						this.homologados=this.homologados+1
						this.noHomologados=this.noHomologados-1
					}
				}
			})
		})
		.catch(() => {
			this.$toast.error("Problema al leer detalle Factura")
			this.listFacturaDetalle = []
			this.listOrdenCompra = []
			this.listHomologaciones = []
				this.listControl = []
				this.factura.llave = {}
		})
	},
	f_ordene_orden(segundos) {
		setTimeout(() => {
			this.listOrdenCompra.sort(function(orden1,orden2) {
				orden1.ordenar=orden1.item_factura
				if	(orden1.item_factura==undefined ||
					orden1.item_factura==null) {
					orden1.ordenar=10000+orden1.cantidad_por_calcular
				}
				orden2.ordenar=orden2.item_factura
				if	(orden2.item_factura==undefined ||
					orden2.item_factura==null) {
					orden2.ordenar=10000+orden2.cantidad_por_calcular
				}
				return orden1.ordenar-orden2.ordenar
			})
		},segundos)
	},
	f_usuario_nombre(id) {
		if	(id === undefined) {
			return "Indefinida"
		}
		const usuario = this.users.find((usuario) => usuario.id == id)
		if	(usuario == undefined) {
			return "Usuario - Inactivo - "+id
		}
		return usuario.name
	},
	f_itemOrdenCompra(r_orden) {
		if	(r_orden.item_factura != undefined ) {
			if	(r_orden.item_factura == this.reg_factura.item) {
				r_orden.item_factura=null
				this.homologados=this.homologados-1
				this.noHomologados=this.noHomologados+1
				r_orden.cantidad_facturada=0
				r_orden.valor_monto_facturado=0
				r_orden.valor_precio_facturado=0
				this.fgl_muestraOrdenCompra=false
				this.fgl_muestraDetalle=true
				if	(r_orden.homologado == false) {
					r_orden.referencia_proveedor=''
					r_orden.descripcion_proveedor=''
				}
			} else{
				this.$toast.error("Item de Orden Compra ya asignado")
			}
			return
		}
		const v_orden = this.listOrdenCompra.find((reg_orden) => reg_orden.item_factura==this.reg_factura.item)
		if	(v_orden == undefined) {
			this.homologados=this.homologados+1
			this.noHomologados=this.noHomologados-1
			if	(this.noHomologados <0 ) {
				this.noHomologados=0
				this.homologados=this.homologados-1
			}
			r_orden.item_factura=this.reg_factura.item
			r_orden.cantidad_facturada=this.reg_factura.cantidad
			r_orden.valor_monto_facturado=this.reg_factura.precio_total
			r_orden.valor_precio_facturado=this.f_precio_factura(
				this.reg_factura.valor_venta,this.reg_factura.impuesto1,this.reg_factura.impuesto2)
			r_orden.impuesto=this.reg_factura.impuesto0
			r_orden.impuesto_adicional=this.f_impuesto_adicional(
				this.reg_factura.impuesto1,this.reg_factura.impuesto2)
			if	(r_orden.homologado == undefined) {
				r_orden.homologado = false
			}
			if	(r_orden.homologado == false) {
				r_orden.referencia_proveedor = this.reg_factura.codigo
				r_orden.descripcion_proveedor = this.reg_factura.descripcion
				r_orden.descripcion_rappi = r_orden.descripcion
			}
		} else {
			if	(v_orden.posicion == r_orden.posicion) {
				this.homologados=this.homologados-1
				this.noHomologados=this.noHomologados+1
				r_orden.item_factura=null
				r_orden.cantidad_facturada=0
				r_orden.valor_monto_facturado=0
				r_orden.valor_precio_facturado=0
				this.fgl_muestraOrdenCompra=false
				this.fgl_muestraDetalle=true
				if	(r_orden.homologado == false) {
					r_orden.referencia_proveedor=''
					r_orden.descripcion_proveedor=''
					r_orden.descripcion_rappi=''
				}
			} else {
				this.$toast.error("Item de Factura ya asignado a item de orden "+v_orden.posicion)
			}
		}
	},
	f_ordenCompra(r_factura) {
		this.reg_factura=r_factura
		this.f_ordene_orden(500)
		this.fgl_muestraOrdenCompra=true
		this.fgl_muestraDetalle=false
	},
	f_actualiza_contab_inicial() {
		this.fgl_muestraDetalle=true
		this.muestreDetalleFactura=false
		this.valor_total_fe = 0
		this.valor_total_sap = 0
		this.documento_contable = ''
	},
	f_actualiza_contab(inicio) {
		if	(this.estado.contabiliza == true && 
			this.factura.documento_contable.length<=2) {
			this.$toast.error("Falta documento Contable")
			return
		}
		let estado_anterior = null
		if	(inicio == true) {
			this.factura.razon_estado=-1
		} else {
			const razon = this.listRazones.find((r_razon) => r_razon.razon==this.factura.razon_estado)
			estado_anterior = this.factura.estado
			this.factura.estado=razon.estado
			this.f_genere_diferencias()
			if	(this.estado.seguimiento == true) {
				this.novedad.pais = this.factura.pais
				this.novedad.tipo_novedad = this.factura.estado
				this.novedad.fecha_novedad = new Date()
				this.novedad.pedido=this.factura.pedido
				this.novedad.remision=this.factura.remision
				this.novedad.documento=this.factura.documento
				this.novedad.factura=this.factura.factura
				this.novedad.archivo=this.factura.archivo
				this.novedad.documento_contable=this.factura.documento_contable
				this.novedad.valor_total=this.factura.valor_total
				this.novedad.razon_social=this.factura.nombre
				this.novedad.rut_proveedor=this.factura.identificacion
				this.novedad.id_lider=this.factura.id_lider
				this.novedad.id_usuario=this.factura.id_usuario
				this.novedad.llave=this.factura.llave
				this.muestreDetalleFactura=false
				this.novedad_detalle.forEach((r_novedad,idx) => {
					this.novedad_detalle[idx].pais = this.novedad.pais
					this.novedad_detalle[idx].tipo_novedad = this.novedad.tipo_novedad
					this.novedad_detalle[idx].fecha_novedad=this.novedad.fecha_novedad
					this.novedad_detalle[idx].pedido=this.novedad.pedido
					this.novedad_detalle[idx].remision=this.novedad.remision
					this.novedad_detalle[idx].documento=this.novedad.documento
					this.novedad_detalle[idx].factura=this.novedad.factura
					this.novedad_detalle[idx].archivo=this.novedad.archivo
					this.novedad_detalle[idx].valor_factura=this.novedad.valor_total
					this.novedad_detalle[idx].razon_social=this.novedad.razon_social
					this.novedad_detalle[idx].rut_proveedor=this.novedad.rut_proveedor
					this.novedad_detalle[idx].llave=this.novedad.llave
					this.novedad_detalle[idx].documento_contable=this.novedad.documento_contable
					this.novedad_detalle[idx].id_lider=this.novedad.id_lider
					this.novedad_detalle[idx].id_usuario=this.novedad.id_usuario
					this.novedad_detalle[idx].estado=null
					this.novedad_detalle[idx].u_crea=this.$store.state.userId 
				})
			} else {
				this.observaciones=''
				this.estado={}
				this.novedad_detalle=[]
			}
			if	(this.estado.contabiliza == false) {
				this.factura.documento_contable=''
			}
		}
			

		var v_factura = {
			factura : this.factura.factura,
			archivo : this.factura.archivo,
			estado_anterior : estado_anterior,
			fecha_estado_anterior : this.factura.updatedAt,
			inicia_contab: this.factura.inicia_contab,
			u_crea: this.$store.state.userId,
			documento_contable : this.factura.documento_contable,
			observaciones : this.observaciones,
			novedad_detalle : this.novedad_detalle
		}
		Factura.grabeContab(this.factura.id,inicio,this.factura.razon_estado,this.factura.estado,v_factura)
		.then(() => {
			if	(inicio) {
				this.$toast.success("Contabilizacion Iniciada")
			} else {
				this.$toast.success("Estado Cambiado")
			}
			this.muestreDetalleFactura=false
			this.contabilizaFactura=false
			this.fgl_novedad=false
			this.fgl_diferencias=false
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al cambiar estado")
		})
	},
	f_seleccione_facturas() {
		this.listFacturas = this.listFacturasG.filter((factura) => factura.pais == this.pais)
	},
	f_pide_adicional() {
		this.f_razon(this.factura.razon_estado)
		if	(this.estado.contabiliza == true || 
			this.estado.observaciones == true) {
			this.adicional=true
		} else {
			this.adicional = false
			this.grabar = true
		}
		if	(this.estado.contabiliza == false && 
			this.estado.observaciones == true) {
			this.grabar=true
		}
	},
	f_estado(estado) {
		if	(estado == null || estado == undefined) {
			return ""
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado == estado)
		if	(v_estado == undefined || v_estado == null) {
			return estado
		}
		return v_estado.descripcion
	},

	f_razon(razon) {
		if	(this.listRazones.length==0) {
			this.listRazones=this.listRazonesLeidas
		}
		const v_razon = this.listRazones.find((r_razon) => r_razon.razon == razon)
		this.estado = this.listEstados.find((r_estado) => r_estado.estado == v_razon.estado)
	},
	f_verifique_doc_contable(p_doc_contable) {
		var fgl_error = false
		if	(p_doc_contable.length == 1) {
			if	(p_doc_contable != "3" &&
				p_doc_contable != "8" &&
				p_doc_contable != "1" &&
				p_doc_contable != "2") {
				fgl_error = true
			}
		}
		if	(p_doc_contable.length == 2) {
			if	(p_doc_contable != "39" &&
				p_doc_contable != "87" &&
				p_doc_contable != "18" &&
				p_doc_contable != "21") {
				fgl_error = true
			}
		}
		if	(p_doc_contable.length > 2) {
			if	(p_doc_contable.substr(0,2) != "39" &&
				p_doc_contable.substr(0,2) != "87" &&
				p_doc_contable.substr(0,2) != "18" &&
				p_doc_contable.substr(0,2) != "21") {
				fgl_error = true
			}
		}
		if	(fgl_error == true) {
			this.factura.documento_contable='39'
			this.$toast.success("Documento debe comenzar por Facturas(39,87) NC/ND(18,21)")
		} else {
			this.grabar=true
		}
	},
	f_adicione_novedad_item() {
		this.novedad_detalle.push(this.novedad_item)	
		this.novedad_item={}
	},
	f_diferencias(valor_fe,valor_sap) {
		let v_valor=valor_fe.toString()
		v_valor=v_valor.replace(',','.')
		valor_fe=parseFloat(v_valor)
		v_valor=valor_fe-valor_sap
		v_valor=v_valor.toFixed(2)
		return v_valor
	},
	f_diferencias_total(precio_fe,precio_sap,iva_fe,iva_sap,impuesto_fe,impuesto_sap) {
		if	(iva_fe == undefined || iva_fe == null) {
			iva_fe="0"
		}
		if	(impuesto_fe == undefined || impuesto_fe == null) {
			impuesto_fe="0"
		}
		precio_fe=precio_fe.replace(',','.')
		let v_valor_fe=parseFloat(precio_fe)+parseFloat(iva_fe)+parseFloat(impuesto_fe)
		precio_sap=precio_sap.replace(',','.')
		let v_valor_sap=parseFloat(precio_sap)+parseFloat(iva_sap)+parseFloat(impuesto_sap)
		const v_valor=v_valor_fe-v_valor_sap
		return v_valor.toFixed(2)
	},
	f_valor_fe(precio_fe,iva_fe) {
		if	(iva_fe == undefined || iva_fe == null) {
			iva_fe="0"
		}
		precio_fe=precio_fe.replace(',','.')
		let v_valor_fe=parseFloat(precio_fe)+
			parseFloat(iva_fe)
		return v_valor_fe.toFixed(2)
	},
	f_valor_sap(precio_sap,iva_sap,impuesto_sap) {
		precio_sap=precio_sap.replace(',','.')
		let v_valor_sap=parseFloat(precio_sap)+
			parseFloat(iva_sap)+parseFloat(impuesto_sap)
		return v_valor_sap.toFixed(2)
	},
	f_actualiza_diferencias() {
		this.valor_total_fe = 0
		this.valor_total_sap = 0
		this.novedad_detalle.forEach((r_novedad) => {
			this.valor_total_fe = parseFloat(this.valor_total_fe)+
			parseFloat(this.f_valor_fe(r_novedad.precio_fe,
				r_novedad.iva_fe))
			this.valor_total_sap = parseFloat(this.valor_total_sap)+
			parseFloat(this.f_valor_sap(r_novedad.precio_sap,
				r_novedad.iva_sap,r_novedad.impuesto_adicional_sap))
		})
	},
	f_cierre_factura_detalle() {
		this.fgl_muestraDetalle=false
		this.muestreDetalleFactura=true
		this.f_visualizar(false)
	},
	f_genere_diferencias() {
		this.fgl_diferencias=true
		this.fgl_novedad=false
		this.novedad_detalle=[]
		this.novedad_item={}
		this.listOrdenFacturas.forEach((orden) => {
			if	(orden.item_factura > 0) {

				this.novedad_item.item=orden.item_factura
				this.novedad_item.descripcion=orden.descripcion_factura
				this.novedad_item.cantidad_fe=orden.cantidad_facturada
				this.novedad_item.precio_fe=orden.valor_precio_facturado
				this.novedad_item.monto_fe=orden.valor_monto_facturado
				this.novedad_item.iva_fe=orden.impuesto
				this.novedad_item.impuesto_adicional_fe=orden.impuesto_adicional
				if	(orden.posicion == null) {
					this.novedad_item.cantidad_sap=0
					this.novedad_item.precio_sap=0
					this.novedad_item.monto_sap=0
					this.novedad_item.iva_sap=0
					this.novedad_item.impuesto_adicional_sap=0
					this.novedad_item.homologado=false
					this.novedad_item.referencia_proveedor=''
					this.novedad_item.descripcion_proveedor=''
					this.novedad_item.referencia=''
				} else {
					this.novedad_item.cantidad_sap=orden.cantidad_por_calcular
					this.novedad_item.precio_sap=orden.valor_por_calcular
					this.novedad_item.monto_sap=orden.monto_neto
					this.novedad_item.iva_sap=0
					this.novedad_item.impuesto_adicional_sap=0
					this.novedad_item.homologado=orden.homologado
					this.novedad_item.referencia_proveedor=orden.referencia_proveedor
					this.novedad_item.descripcion_proveedor=orden.descripcion_proveedor
					this.novedad_item.descripcion_rappi=orden.descripcion_rappi
					this.novedad_item.referencia=orden.material
				}
				this.f_adicione_novedad_item()
			}
		})
	},
	f_precio_factura(valor,impuesto1,impuesto2) {
		if	(valor == undefined || valor == null) {
			valor="0"
		}
		if	(impuesto1 == undefined || impuesto1 == null) {
			impuesto1="0"
		}
		if	(impuesto2 == undefined || impuesto2 == null) {
			impuesto2="0"
		}
		let v_valor=parseFloat(valor.replace(',','.'))
		let v_impuesto1=parseFloat(impuesto1.replace(',','.'))
		let v_impuesto2=parseFloat(impuesto2.replace(',','.'))
		let v_resultado = v_valor+v_impuesto1+v_impuesto2
		return v_resultado.toFixed(2)
	},
	f_impuesto_adicional(impuesto1,impuesto2) {
		if	(impuesto1 == undefined || impuesto1 == null) {
			impuesto1="0"
		}
		if	(impuesto2 == undefined || impuesto2 == null) {
			impuesto2="0"
		}
		let v_impuesto1=parseFloat(impuesto1.replace(',','.'))
		let v_impuesto2=parseFloat(impuesto2.replace(',','.'))
		let v_resultado = v_impuesto1+v_impuesto2
		return v_resultado.toFixed(2)
	},
	f_visualizar(visualizar) {
		this.grabar=false
		this.estado={}
		this.factura.documento_contable=''
		this.factura.razon_estado=''
		this.observaciones=''
		if	(visualizar == true) {
			this.valores=true
			this.muestreDetalleFactura=false
			this.fgl_visualizaOrdenCompra=true
		}
		this.listOrdenFacturas=this.listOrdenCompra.filter((orden)=> orden.item_factura>0)
		this.listOrdenFacturas.sort(function(orden1,orden2) {
			return orden1.posicion-orden2.posicion
		})
		if	(this.listOrdenFacturas.length>0) {
			this.listRazones=this.listRazonesLeidas
		} else {
			this.f_razones_leidas()
		}
		this.listFacturaDetalle.forEach((detalle) => {
			const v_orden = this.listOrdenCompra.findIndex((orden) => orden.item_factura == detalle.item)
			if	(v_orden < 0) {
				let v_orden = {}
				v_orden.posicion = null
				v_orden.codigo = null
				v_orden.cantidad = detalle.cantidad
				v_orden.descripcion = detalle.descripcion
				v_orden.descripcion_factura = detalle.descripcion
				v_orden.venta_bruta = null
				v_orden.item_factura=detalle.item
				v_orden.cantidad_facturada=detalle.cantidad
				v_orden.valor_precio_facturado= this.f_precio_factura(
					detalle.valor_venta,detalle.impuesto1,detalle.impuesto2)
				v_orden.impuesto=detalle.impuesto0
				v_orden.impuesto_adicional=this.f_impuesto_adicional(
				detalle.impuesto1,detalle.impuesto2)
				this.listOrdenFacturas.push(v_orden)
			} else {
				this.listOrdenCompra[v_orden].descripcion_factura=detalle.descripcion
			}
		})
		if	(visualizar == false) {
			this.f_cierre_visualizacion(false)
		}
	},
	f_valores_item(item,cantidad,valor_sap,valor_fac,cantidad_sap,cantidad_fac) {
		if	(valor_sap == undefined) {
			valor_sap="0.0"
		}
		if	(cantidad_sap == undefined) {
			cantidad_sap="0"
		}
		const v_valor_sap = valor_sap
		const v_cantidad_sap = cantidad_sap
		valor_sap=valor_sap.replace(",",".")
		valor_fac=valor_fac.replace(",",".")
		cantidad_sap=cantidad_sap.replace(",",".")
		cantidad_fac=cantidad_fac.replace(",",".")
		if	(parseFloat(cantidad_sap).toFixed(4) > parseFloat(cantidad_fac).toFixed(4)) {
			cantidad_sap=cantidad_fac
			valor_sap=valor_fac
		} else {
			if	(parseFloat(cantidad_sap).toFixed(4) < parseFloat(cantidad_fac).toFixed(4)) {
				let valorUnitario=parseFloat(valor_fac).toFixed(2)/parseFloat(cantidad_fac).toFixed(4)
				valor_sap=parseFloat(parseFloat(cantidad_sap).toFixed(4)*valorUnitario).toFixed(2)
			} else {
				valor_sap=valor_fac
			}
		}
		if	(item == undefined) {
			if	(cantidad == true) {
				return cantidad_fac
			} else {
				return valor_fac
			}
		}
		if	(cantidad == true) {
			if	(cantidad_sap == v_cantidad_sap) {
				return null
			}
			return cantidad_sap.replace('.',',')
		} else {
			if	(parseFloat(valor_sap).toFixed(2) == parseFloat(v_valor_sap).toFixed(2)) {
				return null
			}
			return valor_sap.replace('.',',')
		}
	},
	f_diferencias_item(item,cantidad,valor_sap,valor_fac,cantidad_sap,cantidad_fac) {
		if	(valor_sap == undefined) {
			valor_sap="0.0"
		}
		if	(cantidad_sap == undefined) {
			cantidad_sap="0"
		}
		valor_sap=valor_sap.replace(",",".")
		valor_fac=valor_fac.replace(",",".")
		cantidad_sap=cantidad_sap.replace(",",".")
		cantidad_fac=cantidad_fac.replace(",",".")
		if	(parseFloat(cantidad_sap).toFixed(4) > parseFloat(cantidad_fac).toFixed(4)) {
			cantidad_sap=cantidad_fac
			valor_sap=valor_fac
		} else {
			if	(parseFloat(cantidad_sap).toFixed(4) < parseFloat(cantidad_fac).toFixed(4)) {
				let valorUnitario=parseFloat(valor_fac).toFixed(2)/parseFloat(cantidad_fac).toFixed(4)
				valor_sap=parseFloat(parseFloat(cantidad_sap).toFixed(4)*valorUnitario).toFixed(2)
			} else {
				valor_sap=valor_fac
			}
		}
		if	(item == undefined) {
			if	(cantidad == true) {
				return cantidad_fac
			} else {
				return valor_fac
			}
		}
		let diferenciaQ=cantidad_fac-cantidad_sap
		let diferenciaP=parseFloat(valor_fac).toFixed(2)-
				parseFloat(valor_sap).toFixed(2)
		if	(cantidad == true) {
			if	(parseFloat(diferenciaQ).toFixed(4) == 0) {
				return null
			}
			return parseFloat(diferenciaQ).toFixed(4).replace('.',',')
		} else {
			if	(parseFloat(diferenciaP).toFixed(2) == 0) {
				return null
			}
			return parseFloat(diferenciaP).toFixed(2).replace('.',',')
		}
	},
	f_cierre_visualizacion(visualizar) {
		this.grabar=false
		this.estado={}
		this.factura.documento_contable=''
		this.factura.razon_estado=''
		this.observaciones=''
		if	(visualizar == true) {
			this.fgl_visualizaOrdenCompra=false
			this.muestreDetalleFactura=true
		}
		this.diferencias=0
		this.listOrdenFacturas.forEach((orden,idx) => {
			this.listOrdenFacturas[idx].diferenciaQ=this.f_diferencias_item(
				orden.posicion,true,
				orden.valor_por_calcular,orden.valor_precio_facturado,
				orden.cantidad_por_calcular,orden.cantidad_facturada)
			this.listOrdenFacturas[idx].diferenciaP=this.f_diferencias_item(
				orden.posicion,false,
				orden.valor_por_calcular,orden.valor_precio_facturado,
				orden.cantidad_por_calcular,orden.cantidad_facturada)
			this.listOrdenFacturas[idx].ajusteQ=this.f_valores_item(
				orden.posicion,true,
				orden.valor_por_calcular,orden.valor_precio_facturado,
				orden.cantidad_por_calcular,orden.cantidad_facturada)
			this.listOrdenFacturas[idx].ajusteP=this.f_valores_item(
				orden.posicion,false,
				orden.valor_por_calcular,orden.valor_precio_facturado,
				orden.cantidad_por_calcular,orden.cantidad_facturada)
			if	(this.listOrdenFacturas[idx].diferenciaQ != null) {
				this.diferencias=parseFloat(this.diferencias)+
					parseFloat(this.listOrdenFacturas[idx].diferenciaP.replace(',','.'))
			}
		})
		this.diferencias=this.diferencias.toFixed(2)
	},
	f_formato_fecha(fecha) {
		if	(fecha == undefined) {
			return fecha
		}
		const v_dia=fecha.substr(8,2)
		const v_mes=fecha.substr(5,2)
		const v_año=fecha.substr(0,4)
		fecha=v_dia+'.'+v_mes+'.'+v_año
		return fecha
	},
	f_razones_leidas() {
		this.listRazones=[]
		this.listRazonesLeidas.forEach((razon) => {
			const v_estado = this.listEstados.find((r_estado) => r_estado.estado == razon.estado && r_estado.contabiliza == 1
		)
			if	(v_estado == undefined) {
				this.listRazones.push(razon)
			} else {
				if	(this.factura.documento != "FAC" &&
					(v_estado.estado == 2 || v_estado.estado == 30)) {
					this.listRazones.push(razon)
				}
			}
		})
	},
	f_embalaje(cantidad,unidad_embalaje) {
		if	(unidad_embalaje == undefined || unidad_embalaje == null) {
			unidad_embalaje="1"
		}
		if	(parseInt(unidad_embalaje) == 1) {
			return cantidad
		}
		let v_cantidad = parseInt(cantidad)*parseInt(unidad_embalaje)
		return v_cantidad.toString()
	},
	f_fecha_inicia_contab() {
		this.fecha_inicia_contab=new Date()
	}
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}
.md-dialog::-webkit-scrollbar {
	width: 30px; /* Ancho de la barra de desplazamiento */
}
</style>
